/**
 * Noms des cookies de session agence — **sans marqueur `server-only`**.
 *
 * Le client a besoin de ces noms (lecture de l'expiration de l'access token pour planifier la
 * rotation, cf. `components/auth/session-expiry.ts`) ; le reste de `session-cookies.ts` écrit
 * des cookies et reste server-only. Séparer les noms évite de dupliquer des littéraux entre
 * les deux bords, ce qui est exactement le genre de dérive qui déconnecte tout le monde.
 */

/**
 * Access token de la session agence. Non-httpOnly : le client lit son expiration pour
 * déclencher la rotation avant l'échéance (#2461).
 */
export const CATALOG_TOKEN_COOKIE = 'catalogToken';

/** Refresh token de la session agence. httpOnly : jamais exposé au JS. */
export const CATALOG_REFRESH_TOKEN_COOKIE = 'catalogRefreshToken';
